var map = {
	"./en/card_1_2.png": "YN8P",
	"./es/card_1_2.png": "P+dB",
	"./pt/card_1_2.png": "octe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XDCI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_1_2\.png$
// module id = XDCI
// module chunks = 0